import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Styles/LeaveRequest.css";
import Loader from "../../Components/Loader"; 

function TodayLeaves() {
  const [todayLeaves, setTodayLeaves] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);

  const formatDate = (date) => {
    const newDate = new Date(date);
    return newDate.toLocaleDateString("en-GB");
  };

  const calculateTotalDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const timeDifference = end - start;
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return daysDifference + 1; 
  };

  const fetchTodayLeaves = async () => {
    setLoading(true);
    setError(null); // Clear any previous errors
    
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("No authentication token found. Please log in.");
        throw new Error("No authentication token found");
      }
  
      let facultyLeaves = [];
      let studentLeaves = [];
      
      // Try to fetch faculty leaves
      try {
        const facultyResponse = await axios.get(
          "https://api.uniums.com/api/faculty/today-leaves",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        
        facultyLeaves = (facultyResponse.data.data || []).map((leave) => ({
          ...leave,
          userType: "Faculty",
        }));
      } catch (facultyErr) {
        console.error("Error fetching faculty leaves for today:", facultyErr);
        // Instead of setting error state, we'll just continue with empty faculty leaves
      }
  
      // Try to fetch student leaves
      try {
        const studentResponse = await axios.get(
          "https://api.uniums.com/api/student/today-leaves-student",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        
        studentLeaves = (studentResponse.data.data || []).map((leave) => ({
          ...leave,
          userType: "Student",
        }));
      } catch (studentErr) {
        console.error("Error fetching student leaves for today:", studentErr);
        // Instead of setting error state, we'll just continue with empty student leaves
      }
  
      const combinedLeaves = [...facultyLeaves, ...studentLeaves];
      
      if (combinedLeaves.length === 0) {
        setError("No leave requests found for today from either faculty or students.");
      }
      
      setTodayLeaves(combinedLeaves);
    } catch (err) {
      console.error("Error fetching today's leaves:", err);
      setError("Failed to fetch today's leave requests. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTodayLeaves();
  }, []);

  if (loading) {
    return <Loader />; 
  }

  return (
    <div className="leave-management">
      <h1>Today's Leave Requests</h1>
      {/* {error && <p className="error-message">{error}</p>} */}
      <div className="admin-table-container border_top">
        <div className="faculty-table">
          <table>
            <thead>
              <tr className="header_sticky">
                <th className="text_nowrap">SL No</th>
                <th className="text_nowrap">Name</th>
                <th className="text_nowrap">Status</th>
                <th className="text_nowrap">User Type</th>
                <th className="min_width_200">Region</th>
                <th className="text_nowrap">Leave Type</th>
                <th>From Date</th>
                <th>To Date</th>
                <th className="text_nowrap">Total Days</th>
                <th className="admin_remarks">Remarks</th>
              </tr>
            </thead>
            <tbody>
              {todayLeaves.length > 0 ? (
                todayLeaves.map((request, index) => (
                  <tr key={request._id}>
                    <td className="text_nowrap">{index + 1}</td>
                    <td className="text_nowrap">{request.name || "N/A"}</td>
                    <td className="text_nowrap">{request.status || "Pending"}</td>
                    <td className="text_nowrap">{request.userType}</td>
                    <td className="region_th">{request.reason || "N/A"}</td>
                    <td className="text_nowrap">{request.leaveType || "N/A"}</td>
                    <td>{formatDate(request.startDate) || "N/A"}</td>
                    <td>{formatDate(request.endDate) || "N/A"}</td>
                    <td className="text_nowrap">{calculateTotalDays(request.startDate, request.endDate)}</td>
                    <td className="admin_remarks">{request.adminComment || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="error">
                    No approved or rejected leave requests for today.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TodayLeaves;
